import { Component } from '@angular/core';

@Component({
    template: `
        <mat-toolbar color="primary">
            <span fxFlex></span>
            <button mat-button [routerLink]="['/login']">Log In</button> 
        </mat-toolbar>
        <div fxLayoutAlign="center center">
            <h4>You have successfully unsubscribed. Please contact support@attensa.com if you have any questions.</h4>
        <div>
    `
})
export class UnsubscribeComponent {
}